import { Params } from '@angular/router';
import { Company } from '@app/interface/company';

/** Parâmetro de URL que liga o filtro "faturadas hoje" no painel de OS (`?faturadaEm=hoje`). */
export const PANEL_INVOICED_PARAM = 'faturadaEm';
export const PANEL_INVOICED_TODAY = 'hoje';

export interface OsPanelTarget {
  href: string[];
  queryParams: Params;
}

/**
 * Destino do painel novo para um chip (`?chip=`, ids de `PANEL_CHIPS`), compartilhado por menus,
 * cards do dashboard e links fixos. Sem `useNewOsPanel` devolve `null` e o chamador segue na rota
 * legada. `extraQueryParams` leva filtros iniciais, como o de faturadas hoje.
 */
export function osPanelTarget(
  company: Company | null | undefined,
  scope: 'os' | 'budget',
  chip: string,
  extraQueryParams: Params = {}
): OsPanelTarget | null {
  if (!company?.useNewOsPanel) {
    return null;
  }
  return {
    href: ['company', company.id, 'os', scope === 'os' ? 'panel' : 'budget-panel'],
    queryParams: { chip, ...extraQueryParams },
  };
}
